import { render, staticRenderFns } from "./PdfReceipt.vue?vue&type=template&id=338f836b&scoped=true&"
import script from "./PdfReceipt.vue?vue&type=script&lang=js&"
export * from "./PdfReceipt.vue?vue&type=script&lang=js&"
import style0 from "./PdfReceipt.vue?vue&type=style&index=0&id=338f836b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338f836b",
  null
  
)

export default component.exports